<template>
  <div>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand bg-support navbar-light">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="pushmenu"
            href="#"
            role="button"
            v-show="this.$route.name != 'home'"
            ><i class="fas fa-bars"></i
          ></a>
        </li>
        <li
          v-if="mostrarLinkInicioNavbar"
          class="nav-item d-none d-sm-inline-block"
        >
          <router-link
            to="/"
            class="nav-link font-weight-bold text-white"
            >Inicio</router-link
          >
        </li>
        <li
          v-if="mostrarLinkDashboardNavbar"
          class="nav-item d-none d-sm-inline-block"
        >
          <router-link
            :to="dashboardNavbarMeta.path"
            class="nav-link font-weight-bold text-white"
          >
            <i class="fas fa-tachometer-alt mr-1"></i>Dashboard
          </router-link>
        </li>
        <li
          v-if="usuarioTieneVariosClientesPlataforma"
          class="nav-item d-none d-sm-inline-block"
        >
          <a
            href="#"
            class="nav-link font-weight-bold text-white"
            @click.prevent="irACambiarDeCliente"
          >
            <i class="fas fa-exchange-alt mr-1"></i>Cambiar de cliente
          </a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <SolicitudSoporteNavLink />
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a
            href="#"
            class="nav-link font-weight-bold text-white"
            >Contacto</a
          >
        </li>
      </ul>

      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="navbar-search"
            href="#"
            role="button"
          >
            <i class="fas fa-search"></i>
          </a>
          <div class="navbar-search-block">
            <form class="form-inline">
              <div class="input-group input-group-sm">
                <input
                  class="form-control form-control-navbar"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-navbar"
                    type="submit"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                  <button
                    class="btn btn-navbar"
                    type="button"
                    data-widget="navbar-search"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li>

        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown">
          <a
            class="nav-link text-white"
            data-toggle="dropdown"
            href="#"
          >
            <i class="far fa-comments"></i>
            <span class="badge badge-danger navbar-badge">3</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <a
              href="#"
              class="dropdown-item"
            >
              <!-- Message Start -->
              <div class="media">
                <!--  <img
                  src="dist/img/user1-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 mr-3 img-circle"
                /> -->
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    Brad Diesel
                    <span class="float-right text-sm text-danger"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">Call me whenever you can...</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item"
            >
              <!-- Message Start -->
              <div class="media">
                <img
                  src="dist/img/user8-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 img-circle mr-3"
                />
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    John Pierce
                    <span class="float-right text-sm text-muted"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">I got your message bro</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item"
            >
              <!-- Message Start -->
              <div class="media">
                <img
                  src="dist/img/user3-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 img-circle mr-3"
                />
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    Nora Silvester
                    <span class="float-right text-sm text-warning"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">The subject goes here</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item dropdown-footer"
              >See All Messages</a
            >
          </div>
        </li>
        <!-- Notifications Dropdown Menu -->
        <li class="nav-item dropdown">
          <a
            class="nav-link text-white"
            data-toggle="dropdown"
            href="#"
          >
            <i class="far fa-bell"></i>
            <span class="badge badge-warning navbar-badge">15</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span class="dropdown-item dropdown-header">15 Notifications</span>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item"
            >
              <i class="fas fa-envelope mr-2"></i> 4 new messages
              <span class="float-right text-muted text-sm">3 mins</span>
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item"
            >
              <i class="fas fa-users mr-2"></i> 8 friend requests
              <span class="float-right text-muted text-sm">12 hours</span>
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item"
            >
              <i class="fas fa-file mr-2"></i> 3 new reports
              <span class="float-right text-muted text-sm">2 days</span>
            </a>
            <div class="dropdown-divider"></div>
            <a
              href="#"
              class="dropdown-item dropdown-footer"
              >See All Notifications</a
            >
          </div>
        </li>
        <!-- Toggle tema: solo icono luna / sol -->
        <li class="nav-item">
          <a
            class="nav-link text-white"
            href="#"
            role="button"
            :title="darkMode ? 'Usar tema claro' : 'Usar tema oscuro'"
            @click.prevent="toggleDarkMode"
          >
            <i :class="darkMode ? 'fas fa-sun' : 'fas fa-moon'"></i>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i class="fas fa-expand-arrows-alt"></i>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link text-white user-menu-trigger"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="user-menu-trigger__avatar" aria-hidden="true">{{
              inicialesUsuario
            }}</span>
            <span class="user-menu-trigger__label d-none d-md-inline"
              >Perfil</span
            >
          </a>
          <div
            class="dropdown-menu dropdown-menu-right user-dropdown p-0 border-0"
          >
            <div class="user-dropdown__card">
              <div class="user-dropdown__header">
                <div
                  class="user-dropdown__avatar"
                  aria-hidden="true"
                >
                  {{ inicialesUsuario }}
                </div>
                <div class="user-dropdown__identity">
                  <p class="user-dropdown__name mb-0">
                    {{ nombreUsuario }}
                  </p>
                  <p
                    v-if="cargoUsuario"
                    class="user-dropdown__cargo mb-0"
                  >
                    {{ cargoUsuario }}
                  </p>
                </div>
              </div>

              <div class="user-dropdown__datos">
                <div class="user-dropdown__dato">
                  <i class="fas fa-envelope" aria-hidden="true"></i>
                  <span>{{ emailUsuario }}</span>
                </div>
                <div class="user-dropdown__dato">
                  <i class="fas fa-id-card" aria-hidden="true"></i>
                  <span>{{ documentoUsuario }}</span>
                </div>
                <div
                  v-if="celularUsuario"
                  class="user-dropdown__dato"
                >
                  <i class="fas fa-mobile-alt" aria-hidden="true"></i>
                  <span>{{ celularUsuario }}</span>
                </div>
              </div>

              <div class="user-dropdown__actions">
                <router-link
                  to="/PerfilUsuario"
                  class="user-dropdown__action"
                >
                  <i class="fas fa-user" aria-hidden="true"></i>
                  <span>Mi perfil</span>
                </router-link>
                <button
                  type="button"
                  class="user-dropdown__action"
                  data-toggle="modal"
                  data-target="#modal-actualizar-clave"
                >
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <span>Cambiar clave</span>
                </button>
                <button
                  type="button"
                  class="user-dropdown__action user-dropdown__action--danger"
                  @click="logout"
                >
                  <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
    <UpdatePassword></UpdatePassword>
  </div>
</template>
<script>
import UpdatePassword from "../UpdatePassword";
import SolicitudSoporteNavLink from "./SolicitudSoporteNavLink";

/**
 * Líneas de negocio con pantalla Dashboard propia.
 * Si `permission` es string, el enlace solo se muestra con ese permiso Spatie (p. ej. Trafigura).
 * Añadir aquí nuevas líneas cuando exista ruta + criterio de acceso.
 */
const LINEAS_CON_DASHBOARD = {
  6: { path: "/Biomax/Dashboard", permission: null },
  7: { path: "/Trafigura/Dashboard", permission: "trafigura.dashboard.index" },
};

export default {
  name: "NavBarTop",
  components: {
    UpdatePassword,
    SolicitudSoporteNavLink,
  },
  data() {
    return {};
  },
  computed: {
    darkMode() {
      return this.$store.getters.getDarkMode;
    },
    usuario() {
      return this.$store.state.user;
    },
    nombreUsuario() {
      return (this.usuario && this.usuario.name) || "Usuario";
    },
    emailUsuario() {
      return (this.usuario && this.usuario.email) || "—";
    },
    documentoUsuario() {
      const n = this.usuario && this.usuario.n_document;
      if (n === null || n === undefined || String(n).trim() === "") return "—";
      return String(n);
    },
    celularUsuario() {
      const c = this.usuario && this.usuario.cel;
      return c ? String(c) : "";
    },
    cargoUsuario() {
      return (this.usuario && (this.usuario.cargo || this.usuario.charge)) || "";
    },
    inicialesUsuario() {
      const name = String(this.nombreUsuario || "").trim();
      if (!name || name === "Usuario") return "U";
      const parts = name.split(/\s+/).filter(Boolean);
      const a = parts[0] ? parts[0][0] : "U";
      const b = parts.length > 1 ? parts[1][0] : parts[0][1] || "";
      return (a + b).toUpperCase();
    },
    usuarioTieneVariosClientesPlataforma() {
      const u = this.$store.state.user;
      const c = u?.clientes_plataforma ?? u?.clientesPlataforma ?? [];
      return Array.isArray(c) && c.length > 1;
    },
    lineasNegocioFiltradasPorClienteActual() {
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      const u = this.$store.state.user;
      let lineas = u?.lineas_negocio ?? u?.lineasNegocio ?? [];
      if (!Array.isArray(lineas)) lineas = [];
      if (cid == null) return lineas;
      return lineas.filter((l) => {
        const id = l.cliente_plataforma_id ?? l.clientePlataformaId;
        return id != null && Number(id) === Number(cid);
      });
    },
    cantidadLineasNegocioParaContextoActual() {
      const storeLineas = this.$store.getters.getLineasParaClienteActual || [];
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      if (cid != null && storeLineas.length > 0) return storeLineas.length;
      return this.lineasNegocioFiltradasPorClienteActual.length;
    },
    /** Una sola línea para el cliente actual → ocultar Inicio en la barra superior. */
    usuarioTieneUnaSolaLineaNegocio() {
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      if (cid == null) return false;
      return this.cantidadLineasNegocioParaContextoActual === 1;
    },
    mostrarLinkInicioNavbar() {
      return this.$store.state.auth && !this.usuarioTieneUnaSolaLineaNegocio;
    },
    dashboardNavbarMeta() {
      if (!this.$store.state.auth) return null;
      const lid = Number(this.$store.getters.getCurrentLineaNegocioId);
      if (!lid || Number.isNaN(lid)) return null;
      const cfg = LINEAS_CON_DASHBOARD[lid];
      if (!cfg) return null;
      if (cfg.permission && !this.$store.getters.can(cfg.permission))
        return null;
      return cfg;
    },
    mostrarLinkDashboardNavbar() {
      return !!this.dashboardNavbarMeta && this.$route.name !== "home";
    },
  },
  methods: {
    async irACambiarDeCliente() {
      await this.$store.dispatch("prepararCambioDeClientePlataforma");
      if (this.$route.path !== "/") {
        await this.$router.push("/");
      }
    },
    toggleDarkMode() {
      this.$store.dispatch("setDarkMode", !this.darkMode);
    },
    async logout() {
      await this.$store.dispatch("logout");
      await this.$router.push("/login");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.user-menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.user-menu-trigger__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1;
}

.user-menu-trigger__label {
  font-weight: 600;
  font-size: 0.9rem;
}

.user-dropdown {
  min-width: 280px;
  max-width: min(320px, 92vw);
  padding: 0 !important;
  margin-top: 0.35rem !important;
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(15, 47, 88, 0.22) !important;
}

.user-dropdown__card {
  background: #fff;
}

.user-dropdown__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.05rem 0.9rem;
  background: linear-gradient(135deg, #153f75 0%, #0f2f58 58%, #1a4f7a 100%);
  color: #fff;
}

.user-dropdown__avatar {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0.02em;
  color: #153f75;
  background: #bad35c;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.user-dropdown__identity {
  min-width: 0;
}

.user-dropdown__name {
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-dropdown__cargo {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  opacity: 0.85;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-dropdown__datos {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.85rem 1.05rem;
  background: #f7f9fc;
  border-bottom: 1px solid rgba(21, 63, 117, 0.08);
}

.user-dropdown__dato {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  font-size: 0.78rem;
  color: #334155;
  line-height: 1.35;
  word-break: break-word;
}

.user-dropdown__dato i {
  margin-top: 0.15rem;
  width: 0.9rem;
  text-align: center;
  color: #153f75;
  opacity: 0.75;
  flex: 0 0 auto;
}

.user-dropdown__actions {
  display: flex;
  flex-direction: column;
  padding: 0.4rem;
}

.user-dropdown__action {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.75rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #1e293b;
  font-size: 0.86rem;
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.user-dropdown__action i {
  width: 1rem;
  text-align: center;
  color: #153f75;
}

.user-dropdown__action:hover {
  background: rgba(21, 63, 117, 0.08);
  color: #0f2f58;
  text-decoration: none;
}

.user-dropdown__action--danger {
  color: #9f1239;
}

.user-dropdown__action--danger i {
  color: #be123c;
}

.user-dropdown__action--danger:hover {
  background: rgba(190, 18, 60, 0.08);
  color: #9f1239;
}
</style>
<style>
@media (max-width: 767.98px) {
  .left {
    width: 230px;
  }

  .texto {
    font-size: 0.7em;
  }
}
</style>
